export const WARNING = 'warning';
export const DANGER = 'danger';

export const WARNING_MESSAGE_CLASS = 'warning_message';
export const DANGER_MESSAGE_CLASS = 'danger_message';
